import {
  currencyFormat,
  DEFAULT_BASIC_ITEMS,
  DEFAULT_STORE_VALUES,
  MAX_GENKYU_KEKKIN_NISSU,
  RoundingMethodList,
} from "@kg-pos/common";
import { StoreResponse, useDeleteStoreMutation } from "__generated__/graphql";
import { SingleRead } from "components/molecules/single-read";
import { AuthContext } from "contexts/current-user.context";
import React, { useContext } from "react";
import { routeConstants } from "routes";

export const StoreLayout: React.VFC<{ store: StoreResponse }> = ({ store }) => {
  const [deleteStore] = useDeleteStoreMutation();
  const currentUser = useContext(AuthContext).currentUser;

  const { id } = store;
  const handleDelete = async (): Promise<boolean> => {
    return !!(await deleteStore({ variables: { id } })).data?.deleteStore;
  };
  if (!currentUser) return null;
  const { isMaster } = currentUser;

  return (
    <SingleRead
      data={[
        { label: "店舗名", value: store.name },
        // { label: "アイコン", value: store.icon },
        { label: "説明", value: store.description ?? "" },
        { label: "レシートプリンタのIPアドレス", value: store.receiptPrinterIpAddress ?? "" },
        { label: "サービス料", value: `${store.serviceFee}%` },
        {
          label: "注文ロック時間",
          value: `${store.orderItemLockTime?.substring(0, 2)}:${store.orderItemLockTime?.substring(
            2,
            4
          )}`,
        },
        { label: "指名料", value: `${currencyFormat(store.staffReservationFee)}` },
        {
          label: `${DEFAULT_BASIC_ITEMS.tableCharge.itemName}数量`,
          value: store.defaultTableChargeCount,
        },
        { label: "注文通知メールアドレス", value: store.notificationEmailAddress },
        { label: "株式会社名", value: store.companyName },
        { label: "住所", value: store.address },
        { label: "インボイス登録番号", value: store.invoiceNumber },
        { label: "皆勤NG金額", value: currencyFormat(store.kaikinNgAmount) },
        { label: "内勤売上", value: store.naikinUriage ? "あり" : "なし" },
        { label: "内勤皆勤賞", value: store.naikinKaikinSho ? "あり" : "なし" },
        {
          label: "減給欠勤日数",
          value:
            (store.genkyuKekkinNissu ?? DEFAULT_STORE_VALUES.genkyuKekkinNissu) <
            MAX_GENKYU_KEKKIN_NISSU
              ? `${store.genkyuKekkinNissu}日`
              : "なし",
        },
        { label: "ファーストサーブ", value: store.firstServe ? "あり" : "なし" },
        { label: "端数処理方法", value: RoundingMethodList[store.amountRoundingMethod] },
      ]}
      editPath={`${routeConstants.stores}/edit/${id}`}
      // 店舗削除は総合管理者のみ
      {...(isMaster ? { deletePath: routeConstants.stores } : {})}
      handleDelete={handleDelete}
      noContainer
    />
  );
};
